import { SVGPureIcon } from '@/ui';
import chatInputStore from '@/components/chat/ChatInput/store';

const PromptList = ({ data }) => {
  if (!data?.length) {
    return null;
  }

  const handleClick = (item) => {
    chatInputStore.setContent(item);
    setTimeout(() => {
      chatInputStore.inputRef?.focus({
        cursor : "end",
      });
    }, 20);
  }

  return (
    <ul className="mt-16px mb-0">
      {data.slice(0, 4).map(item => {
        if (!item) {
          return null;
        }
        return (
          <li
            key={item}
            className={[
              'flex items-center justify-start gap-10px rounded-12px ',
              'mt-8px pl-4px pr-8px py-10px text-14px text-black',
              'hover:bg-black hover:bg-opacity-3 cursor-pointer',
            ]}
            onClick={() => handleClick(item)}
          >
            <SVGPureIcon size={16} name="prompt_arrow" />
            <span className="flex-1 leading-20px">{item}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PromptList;
